import React, { useState } from "react";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import InvoiceOverlay from "./Components/InvoiceOverlay";
import moment from "moment";
import { toast } from "react-toastify";
import { get_invoice_details_by_invoice_id } from "../../helper/Api";
import Spinner from "../Tools/spinner";

const Invoices = ({data, approval}) => {
  const [checked, setChecked] = React.useState([true, false]);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleChange1 = (event) => {
    setChecked([event.target.checked, event.target.checked]);
  };
  const [overlay, setOverlay] = useState(true);
  const [invoiceDetails, setInvoiceDetails] = useState(null);
  const [detailsLoading, setDetailsLoading] = useState(false);

  const handleChange2 = (event) => {
    setChecked([event.target.checked, checked[1]]);
  };

  const handleChange3 = (event) => {
    setChecked([checked[0], event.target.checked]);
  };
  const label = { inputProps: { "aria-label": "Checkbox demo" } };


  const [cardAccordion, setCardAccordion] = useState(false);

  const children3 = (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#FFF",
      }}
      className="px-3"
    >
      <div className="row">
        <div className="m-0 p-0 d-flex align-items-center col-3">
          <FormControlLabel
            //   sx={{ border: "2px solid red" }}
            control={<Checkbox checked={checked[1]} onChange={handleChange3} />}
            className="p-0 m-0"
          />
          <div className="fs-12px d-flex align-items-center gap-1 p-0 m-0">
            Sanction No: <span className="fs-14px fw-500">1654321</span>
          </div>
        </div>

        <div className="m-0 p-0 d-flex align-items-center col-3">
          <div className="fs-12px d-flex align-items-center gap-1 p-0 m-0">
            Sanction Date: <span className="fs-14px fw-500">1654321</span>
          </div>
        </div>

        <div className="m-0 p-0 d-flex align-items-center col-3">
          <div className="fs-12px d-flex align-items-center gap-1 p-0 m-0">
            Sanction Amount:{" "}
            <span className="fs-14px fw-500">2,000,000,000.00</span>
          </div>
        </div>

        <div className="m-0 p-0 d-flex align-items-center justify-content-end col-3">
          <div className="fs-12px d-flex align-items-center text-link gap-1 p-0 m-0 pe-1">
            {cardAccordion ? (
              <i
                className="icon-remove_circle fs-16px text-primary-50 cursor-pointer"
                onClick={() => setCardAccordion(false)}
              ></i>
            ) : (
              <i
                className="icon-add_circle fs-16px text-primary-50 cursor-pointer"
                onClick={() => setCardAccordion(true)}
              ></i>
            )}
          </div>
        </div>
        {/* {cardAccordion && <div className="row m-0 p-0 px-2">{children}</div>} */}
      </div>

      {/* ==========================subdata======================== */}
    </div>
  );

  const [activeKeys, setActiveKeys] = useState([]);

  const handleInvoiceAccordian = (key) => {
    setActiveKeys(
      (prevKeys) =>
        prevKeys.includes(key)
          ? prevKeys.filter((k) => k !== key)
          : [...prevKeys, key]
    );
  }
  const showInvoiceDetails = async (invoice) => {
    const invoiceId = invoice?.id;
    if (!invoiceId) {
      toast.error("Invoice id not found for this record", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }

    try {
      setDetailsLoading(true);
      const { data } = await get_invoice_details_by_invoice_id(invoiceId);
      if (data?.status) {
        setInvoiceDetails(data.details);
        setOverlay(false);
      } else {
        toast.error(data?.message || "Unable to fetch invoice details", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error(error?.message || "Unable to fetch invoice details", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      setDetailsLoading(false);
    }
  };

  return (
    <div className="p-3">
      {detailsLoading && <Spinner />}
      {!data?.length ? (
        <div className="border-prime-100 border-1 overflow-hidden rounded-3 bg-white text-center text-muted py-5">
          No data found
        </div>
      ) : (
      data.map((sanctionOrder, index) => (
            <div className="border-prime-100 border-1 overflow-hidden rounded-3 mt-2" key={index}>
                <FormControlLabel sx={{ backgroundColor: "#DFF0FF", width: "100%", left: "1%" }} className="position-relative"
                control={
                    <>
                    {
                        approval && <Checkbox
                        checked={checked[0] && checked[1]}
                        indeterminate={checked[0] !== checked[1]}
                        onChange={handleChange1}
                    />
                    }
                    
                    <div className="d-flex justify-content-between align-items-center w-100 px-1 pe-2">
                        <div className="d-flex gap-3 align-items-center">
                        <div className="fs-12px d-flex align-items-center gap-1">
                            Sanction No: <span className="fs-14px fw-500">{sanctionOrder.sanction_order_no}</span>
                        </div>
                        <div className="fs-12px d-flex align-items-center gap-1">
                            Sanction Date:{" "}
                            <span className="fs-14px fw-500">{moment(sanctionOrder.sanction_order_date, 'YYYY-MM-DD').format('DD-MM-YYYY')}</span>
                        </div>
                        </div>

                        <div className="fs-12px d-flex align-items-center gap-1">
                        Total Amount: <span className="fs-14px fw-500">{sanctionOrder.sanction_amount}</span>
                        </div>
                    </div>
                    </>
                }
                />
                {
                    sanctionOrder?.vouchers.map((voucher, voucherIndex) => (
                        <div style={{ display: "flex", flexDirection: "column", backgroundColor: "#FFF"}} className="px-3" key={voucherIndex}>
                            <div className="row position-relative p-2">
                                <div className="m-0 p-0 d-flex align-items-center col-3">
                                    {
                                        approval && 
                                        <FormControlLabel control={<Checkbox checked={checked[0]} onChange={handleChange2} />} className="p-0 m-0"/>
                                    }
                                    <div className="fs-12px d-flex align-items-center gap-1 p-0 m-0">
                                        Voucher No: <span className="fs-14px fw-500">{voucher.voucher_no}</span>
                                    </div>
                                </div>

                                <div className="m-0 p-0 d-flex align-items-center col-3">
                                    <div className="fs-12px d-flex align-items-center gap-1 p-0 m-0">
                                        Voucher Date: <span className="fs-14px fw-500">{moment(voucher.voucher_date, 'YYYY-MM-DD').format('DD-MM-YYYY')}</span>
                                    </div>
                                </div>

                                <div className="m-0 p-0 d-flex align-items-center col-3">
                                    <div className="fs-12px d-flex align-items-center gap-1 p-0 m-0">
                                        Voucher Amount:
                                        <span className="fs-14px fw-500">{voucher.voucher_amount}</span>
                                    </div>
                                </div>

                                <div className="m-0 p-0 d-flex align-items-center justify-content-end col-3">
                                    <div className="fs-12px d-flex align-items-center text-link gap-1 p-0 m-0 pe-1">
                                        {activeKeys.includes(voucher.voucher_id) ? (
                                        <i
                                            className="icon-remove_circle fs-16px text-primary-50 cursor-pointer"
                                            onClick={() => handleInvoiceAccordian(voucher.voucher_id)}
                                        ></i>
                                        ) : (
                                        <i
                                            className="icon-add_circle fs-16px text-primary-50 cursor-pointer"
                                            onClick={() => handleInvoiceAccordian(voucher.voucher_id)}
                                        ></i>
                                        )}
                                    </div>
                                </div>
                                {
                                    activeKeys.includes(voucher.voucher_id) && voucher.invoices.map((invoice, invoiceIndex) => (
                                        <div className="m-0 p-0 px-2 mt-2" key={invoiceIndex}>
                                            <div className="m-0 p-0 d-flex flex-column gap-1">
                                                <div className="row bg-success-20">
                                                    <div className="col-6 d-flex align-items-center">
                                                        {
                                                            approval && <Checkbox {...label} defaultChecked />
                                                        }
                                                        <div className="m-0 p-0 d-flex flex-column">
                                                        <span className="fw-500 fs-14px">
                                                            {invoice.company_name}
                                                        </span>
                                                        <span className=" text-black-60 fs-12px d-flex gap-2 align-items-center">
                                                            <span>Invoice No: {invoice.invoice_no}</span>
                                                            <span>Invoice Date: {moment(invoice.invoice_date, 'YYYY-MM-DD').format('DD-MM-YYYY')}</span>
                                                            <span className="fw-600 text-success-100">
                                                            {invoice.payment_type === '1' ? 'FULL PAYMENT' : 'PART PAYMENT'}
                                                            </span>
                                                        </span>
                                                        </div>
                                                    </div>
                                                    <div className="col-6 m-0 p-0">
                                                        <div className="row m-0 p-0 ">
                                                        <div className="col-2 m-0 p-0 d-flex flex-column justify-content-center">
                                                            <span className="fs-12px">Sanction</span>
                                                            <span className="fs-14px fw-500">{invoice.sanction_amount}</span>
                                                        </div>
                                                        <div className="col-2 m-0 p-0 d-flex flex-column justify-content-center">
                                                            <span className="fs-12px">Invoice</span>
                                                            <span className="fs-14px fw-500">{invoice.invoice_value}</span>
                                                        </div>
                                                        <div className="col-3 m-0 p-0 d-flex flex-column justify-content-center">
                                                            <span className="fs-12px">Payment Amount</span>
                                                            <span className="fs-14px fw-500">{invoice.payable_amount}</span>
                                                        </div>
                                                        <div className="col-5 m-0 p-0 d-flex align-items-center">
                                                            <div className="d-flex justify-content-between align-items-center ">
                                                                <div className="d-flex align-items-center gap-2">

                                                                    <span className={`rounded-2 ${(invoice.approval_status === '1') ? 'bg-success-20' : (invoice.approval_status === '0') ? 'bg-danger-20' : 'bg-warning-20'} d-flex align-items-center px-2 gap-1`}
                                                                    >
                                                                        <span className="fs-12px text-black-60">L2</span>
                                                                        <span><i className={`${(invoice.approval_status === '1') ? 'icon-verified text-success-100' : (invoice.approval_status === '0') ? 'icon-warning_amber text-danger-100' : 'icon-warning_amber text-warning-100'}`} style={{ height: "14px", width: "14px" }}></i></span>
                                                                    </span>

                                                                    <span
                                                                    className={`${(invoice.l3_approval_status === '1') ? 'bg-success-20' : (invoice.l3_approval_status === '0') ? 'bg-danger-20' : 'bg-warning-20'} rounded-2 d-flex align-items-center px-2 gap-1`}
                                                                    >
                                                                        <span className="fs-12px text-black-60">L3</span>
                                                                        <span><i className={`${(invoice.l3_approval_status === '1') ? 'icon-verified text-success-100' : (invoice.l3_approval_status === '0') ? 'icon-warning_amber text-danger-100' : 'icon-warning_amber text-warning-100'}`} style={{ height: "14px", width: "14px" }}></i></span>
                                                                    </span>

                                                                    <span>
                                                                        <div className="d-flex gap-3 align-items-center">
                                                                            <i className="icon-remove_red_eye text-info-100"
                                                                            onClick={() => showInvoiceDetails(invoice)}
                                                                            ></i>
                                                                            {/* <i className="icon-edit text-success-100"></i> */}
                                                                            {/* <i className="icon-delete_outline text-danger-100"></i> */}
                                                                        </div>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }
                                
                            </div>

                            {/* <div className="row px-2">
                                <div className="m-0 p-0 d-flex align-items-center col-3">
                                    {
                                        approval && <FormControlLabel
                                        control={<Checkbox checked={checked[1]} onChange={handleChange3} />}
                                        className="p-0 m-0"
                                        />
                                    }
                                    <div className="fs-12px d-flex align-items-center gap-1 p-0 m-0">
                                        Voucher No: <span className="fs-14px fw-500">1654321</span>
                                    </div>
                                </div>

                                <div className="m-0 p-0 d-flex align-items-center col-3">
                                    <div className="fs-12px d-flex align-items-center gap-1 p-0 m-0">
                                        Voucher Date: <span className="fs-14px fw-500">1654321</span>
                                    </div>
                                </div>

                                <div className="m-0 p-0 d-flex align-items-center col-3">
                                    <div className="fs-12px d-flex align-items-center gap-1 p-0 m-0">
                                        Voucher Amount:{" "}
                                        <span className="fs-14px fw-500">2,000,000,000.00</span>
                                    </div>
                                </div>

                                <div className="m-0 p-0 d-flex align-items-center justify-content-end col-3">
                                    <div className="fs-12px d-flex align-items-center text-link gap-1 p-0 m-0 pe-1" style={{ textDecoration: "underline" }}>
                                        View Invoice
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    ))
                }
            </div>
        ))
      )}

      

      {/* ===============================second card============================ */}

      {/* <div className="border-prime-100 border-1 overflow-hidden rounded-3 mt-3">
        <FormControlLabel
          // label="Parent"
          sx={{ backgroundColor: "#28326F", width: "100%", left: "1%" }}
          className="position-relative text-white"
          control={
            <>
              <Checkbox
                checked={checked[0] && checked[1]}
                indeterminate={checked[0] !== checked[1]}
                onChange={handleChange1}
              />
              <div className="d-flex justify-content-between align-items-center w-100 px-1 pe-2">
                <div className="d-flex gap-3 align-items-center">
                  <div className="fs-12px d-flex align-items-center gap-1">
                    Sanction No: <span className="fs-14px fw-500">1654321</span>
                  </div>
                  <div className="fs-12px d-flex align-items-center gap-1">
                    Sanction Date:{" "}
                    <span className="fs-14px fw-500">25/12/5243</span>
                  </div>
                </div>

                <div className="fs-12px d-flex align-items-center gap-1">
                  Total Amount: <span className="fs-14px fw-500">255612</span>
                </div>
              </div>
            </>
          }
        />
        {children}
      </div> */}
      {/* ===============================third card============================ */}

      {/* <div className="border-prime-100 border-1 overflow-hidden rounded-3 mt-3">
        <FormControlLabel
          // label="Parent"
          sx={{ backgroundColor: "#2490EA", width: "100%", left: "1%" }}
          className="position-relative text-white"
          control={
            <>
              <Checkbox
                checked={checked[0] && checked[1]}
                indeterminate={checked[0] !== checked[1]}
                onChange={handleChange1}
              />
              <div className="d-flex justify-content-between align-items-center w-100 px-1 pe-2">
                <div className="d-flex gap-3 align-items-center">
                  <div className="fs-16px d-flex align-items-center gap-1 fw-600">
                    A Uttarakhand Purv Sainik Kalyan Nigam ltd.
                  </div>
                </div>
                <div className="d-flex  gap-2">
                  <div className="fs-12px d-flex align-items-center gap-1">
                    sensation: <span className="fs-14px fw-500">255612</span>
                  </div>
                  <div className="fs-12px d-flex align-items-center gap-1">
                    Invoice Amount:{" "}
                    <span className="fs-14px fw-500">255612</span>
                  </div>
                  <div className="fs-12px d-flex align-items-center gap-1">
                    Payment: <span className="fs-14px fw-500">255612</span>
                  </div>
                </div>
              </div>
            </>
          }
        />
        {children3}
      </div> */}
      

      {/* ===========================overlay========================= */}

      <InvoiceOverlay
        overlay={overlay}
        setOverlay={setOverlay}
        invoiceDetails={invoiceDetails}
      />
    </div>
  );
};
export default Invoices;
